export default __webpack_public_path__ + "static/media/03.a976b00a.png";